import PersonaList from "./PersonaList";
import BrandPane from "./BrandPane";
import NavigationPane from "./NavigationPane";

const PersonaLibraryPage = () => {
    return (
        <div className="flex h-screen bg-gray-100">
            {/* Brand Pane */}
            <BrandPane />

            {/* Navigation Pane */}
            <NavigationPane />

            {/* Main content */}
            <div className="flex-1 overflow-y-auto">
                {/* Header */}
                <div className="p-6 flex justify-end bg-white sticky top-0 z-10">
                    <img
                        src="/synthio_logo_with_text.png"
                        alt="SynthioLabs Logo"
                        className="h-8 w-auto"
                    />
                </div>
                <div className="flex items-center gap-4 px-8 bg-white">
                    <h1 className="text-2xl font-bold text-gray-800 mb-0">
                        MLR Review Expert Personas custom built for your brand
                    </h1>
                </div>
                <PersonaList />
            </div>
        </div>
    );
};

export default PersonaLibraryPage;
